import Vue from "vue";
import store from "./store";
import App from "./App.vue";
import router from "./router";
import "./plugins";

import axios from "axios";
import moment from "moment";
import DOMPurify from "dompurify";

window.__APP_META__ = {
  buildTime: new Date().toISOString(),
  versions: {
    vue: Vue.version,
    axios: axios && axios.VERSION,
    moment: moment && moment.version,
    dompurify: DOMPurify && DOMPurify.version
  }
};

Vue.config.productionTip = false;

if (performance.navigation.type === 1) {
  localStorage.removeItem("view_as");
}

new Vue({
  store,
  render: h => h(App),
  router
}).$mount("#app");
